module.exports = __webpack_public_path__ + "img/bannerBlue.b6bcedbe.jpg";